<template>
  <div class="overlay">
    <div class="popUp form row d-flex p-0 pb-3" style="width: 20%">
      <em
        @click="$parent.$parent.shwBundlePopUp = false"
        class="bi-x-lg position-sticky pr-3 mb-3 d-flex justify-content-end"
        style="top: 7px"
      ></em>
      <div
        class="col-md-6 d-flex flex-column align-items-center overflow-hidden"
      >
        <select v-model="selectedItem" v-if="selectedType === 'api'">
          <option :value="item" v-for="(item, index) in list[0]" :key="index">
            {{ item.name }}
          </option>
        </select>
        <select v-model="selectedItem" v-else>
          <option :value="item" v-for="(item, index) in list[0]" :key="index">
            {{ item.name }}
          </option>
        </select>
        <button
          class="btn btn-sm btn-primary mt-3"
          @click="
            bindConnectionToDomain([
              $route.params.id,
              selectedItem.id,
              {},
              selectedItem,
              selectedType,
            ]).then(() => {
              if (selectedType === 'api') {
                getAPIConnections($route.params.id).then((response) => {
                  list = [];
                  list.push(response.data.data);
                  $parent.$parent.shwBundlePopUp = false;
                });
              } else if (selectedType === 'db') {
                getDBConnections($route.params.id).then((response) => {
                  list = [];
                  list.push(response.data.data);
                  $parent.$parent.shwBundlePopUp = false;
                });
              }
            })
          "
        >
          Bind
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AddNewBundle",
  props: ["selectedType"],
  data() {
    return {
      list: [],
      selectedItem: "",
    };
  },
  mounted() {
    if (this.selectedType === "api") {
      this.getConnections("?where[type]=api").then((response) => {
        this.list.push(response.data.data);
      });
    } else if (this.selectedType === "db") {
      this.getConnections("?where[type]=db").then((response) => {
        this.list.push(response.data.data);
      });
    }
  },
  computed: {
    // ...mapState({
    //   api_connections: (state) => state.connections.api_connections,
    //   db_connections: (state) => state.connections.db_connections,
    // }),
  },
  methods: {
    ...mapActions([
      "getConnections",
      "bindConnectionToDomain",
      "getDBConnections",
      "getAPIConnections",
    ]),
  },
};
</script>